import type { PayloadAction } from '@reduxjs/toolkit';

import { isPreApprovalOffer } from 'shared/lib';
import { getPreApprovalResultMap } from 'shared/lib/getPreApprovalResultMap';
import type { TStatusesV2Response } from 'shared/types/TRankingService';

import type { IOffersState } from 'entities/offers';

import { getOffersToShowFromHiddenOffers } from '../../../lib/getOffersToShowFromHiddenOffers';

import { updatePreApprovingOffer, isPreApprovalFailedOffer } from './helpers';

export const setPreApprovingOffersData = (state: IOffersState, { payload }: PayloadAction<TStatusesV2Response>) => {
  const { preApprovalResult } = payload || {};
  const { items = [], status = 'searching' } = preApprovalResult || {};

  const preApprovalResultMap = getPreApprovalResultMap(items);

  const offers = state.offers.reduce<typeof state.offers>((acc, offer) => {
    // НЕ предодобы не трогаем
    if (!isPreApprovalOffer(offer)) {
      acc.push(offer);
      return acc;
    }

    // обновляем оффер данными из statuses v2
    const updatedOffer = updatePreApprovingOffer(offer, preApprovalResultMap);

    // если общий статус поллинга COMPLETE, но данные по офферу так и не пришли, то такой оффер нужно отфильтровать
    if (status === 'complete' && updatedOffer?.additionalInfo?.isPreapproving) {
      return acc;
    }

    acc.push(updatedOffer);
    return acc;
  }, []);

  const { offersToShow, remainingHiddenOffers } = getOffersToShowFromHiddenOffers({
    hiddenOffers: state.hiddenOffers,
    hiddenOfferIds: offers
      .filter((o) => isPreApprovalFailedOffer(o) && o.exchangeOfferId)
      .map((o) => o.exchangeOfferId) as string[],
    targetGroup: 'SuitableAll',
  });

  state.hiddenOffers = remainingHiddenOffers;
  state.offers = [...offersToShow, ...offers.filter((o) => !isPreApprovalFailedOffer(o))];
};
